import { ProductInformationPanel } from './ProductInformationPanel';
import { VendorStatusPanel } from './VendorStatusPanel';
import type { ExtractionResult, Product, ProductCategory, Vendor } from '../../../types/api';

interface ReviewDetailsStepProps {
  extraction: ExtractionResult;
  categories: ProductCategory[];
  products: Product[];
  productsLoading: boolean;
  categoryId: number | '';
  onCategoryChange: (categoryId: number | '') => void;
  selectedProductIds: Set<number>;
  onToggleProduct: (productId: number) => void;
  vendors: Vendor[];
  selectedVendorIds: Set<number>;
  onToggleVendor: (vendorId: number) => void;
  onToggleAllVendors: (checked: boolean) => void;
  title: string;
  onTitleChange: (value: string) => void;
  dueDate: string;
  onDueDateChange: (value: string) => void;
  notes: string;
  onNotesChange: (value: string) => void;
}

/** Step 2 of the wizard - "Extract & Review Details" (design frames RFP 04 / RFP 06). */
export function ReviewDetailsStep({
  extraction,
  categories,
  products,
  productsLoading,
  categoryId,
  onCategoryChange,
  selectedProductIds,
  onToggleProduct,
  vendors,
  selectedVendorIds,
  onToggleVendor,
  onToggleAllVendors,
  title,
  onTitleChange,
  dueDate,
  onDueDateChange,
  notes,
  onNotesChange,
}: ReviewDetailsStepProps) {
  return (
    <>
      <ProductInformationPanel
        extraction={extraction}
        categories={categories}
        products={products}
        productsLoading={productsLoading}
        categoryId={categoryId}
        onCategoryChange={onCategoryChange}
        selectedProductIds={selectedProductIds}
        onToggleProduct={onToggleProduct}
      />

      <VendorStatusPanel
        vendors={vendors}
        selectedVendorIds={selectedVendorIds}
        onToggleVendor={onToggleVendor}
        onToggleAllVendors={onToggleAllVendors}
        title={title}
        onTitleChange={onTitleChange}
        dueDate={dueDate}
        onDueDateChange={onDueDateChange}
        notes={notes}
        onNotesChange={onNotesChange}
      />
    </>
  );
}
